import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AccountActivation, type ActivatedUser } from "./account-activation.content";
import { useAccountActivation } from "./use-account-activation";
import { defaultValues, schema, type AccountActivationFormInputs } from "./form-validation/account-activation.schema";

interface Props {
  user: ActivatedUser;
  userId: string;
  token: string;
}

export const AccountActivationFormContainer = ({ user, userId, token }: Props) => {
  const form = useForm<AccountActivationFormInputs>({
    resolver: yupResolver(schema),
    defaultValues: { ...defaultValues, name: user.name, lastName: user.lastName, mobile: user.mobile ?? "" },
  });
  const { activate } = useAccountActivation(form, userId, token);

  return <AccountActivation user={user} form={form} onSubmit={form.handleSubmit(activate)} />;
};
